module.exports = __webpack_public_path__ + "static/media/byrne.98f6ba63.png";